import styled from "styled-components";

export default styled.div`
  display: inline-block;
  vertical-align: top;
  font-size: 1rem;
  padding: 1.125em 2.9375rem;
  cursor: pointer;
  text-transform: uppercase;
  color: #ffffff;
  font-family: "CircularStd-Book", sans-serif;
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
  border-radius: 1000px;
  background-color: #f76267;
  @media (max-width: 680px) {
    font-size: 0.8rem;
  }
  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
    background-color: #e8e7e5;
  `};
  ${({ bordered }) =>
    bordered &&
    `
    background-color: transparent;
    border: 2px solid #000;
    color: #000000;
  `};
  @media (max-width: 680px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  ${({ next }) =>
    next &&
    `
    @media (max-width: 680px) {
      border-radius: unset;
      width: 100%;
      padding: 1.5rem 1rem;
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/components/generic/kit/ButtonRound/index.js